module.exports = __webpack_public_path__ + "img/9788988138328.6a7208fd.jpg";